// Argus — User layout preferences API helpers (persist floating windows MDI).
// Endpoints: GET /api/v1/me/layout-preferences, PUT, DELETE /me/layout-preferences/{agentId}/{panelType}.

import { apiFetch } from './api';

export type PanelType =
  | 'fileExplorer'
  | 'desktop'
  | 'webcam'
  | 'mic'
  | 'systemInfo'
  | 'urlMonitoring'
  | 'settings'
  // Bloc task-manager-services 2026-05-07
  | 'taskManager'
  | 'services'
  // Bloc remote-powershell-shell 2026-05-08
  | 'powerShell';

export interface LayoutPreference {
  readonly agentId: string;
  readonly panelType: PanelType;
  // Rect natural (drag-able). Persistat indiferent dacă fereastra e maximizată acum.
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly zOrder: number;
  readonly isOpen: boolean;
  readonly isMaximized: boolean;
  readonly isMinimized: boolean;
  readonly updatedAt: string;
}

export interface UpsertLayoutPreference {
  readonly agentId: string;
  readonly panelType: PanelType;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly zOrder: number;
  readonly isOpen: boolean;
  readonly isMaximized?: boolean;
  readonly isMinimized?: boolean;
}

export async function fetchLayoutPreferences(): Promise<LayoutPreference[]> {
  const result = await apiFetch<{ items: LayoutPreference[] }>(
    '/api/v1/me/layout-preferences'
  );
  return result.data.items;
}

export async function upsertLayoutPreference(
  pref: UpsertLayoutPreference
): Promise<void> {
  await apiFetch<UpsertLayoutPreference>('/api/v1/me/layout-preferences', {
    method: 'PUT',
    body: JSON.stringify(pref),
  });
}

export async function deleteLayoutPreference(
  agentId: string,
  panelType: PanelType
): Promise<void> {
  await apiFetch<{ deleted: number }>(
    `/api/v1/me/layout-preferences/${agentId}/${panelType}`,
    { method: 'DELETE' }
  );
}

export async function touchAgent(agentId: string): Promise<void> {
  await apiFetch<{ agentId: string }>(`/api/v1/agents/${agentId}/touch`, {
    method: 'POST',
  });
}
